import { request } from '@src/utils/request';
import type { AuthInfoResult, LoginData, PhoneRegisterData, PortalBannerItem, SendMsgParams, WechatQrcodeParams, WechatQrcodeResult } from './types';

// GET /userservice/auth/wechat/qrcode/USER_LOGIN - 微信公众号扫码登录
export const wechatQrcode = (params: WechatQrcodeParams) =>
    request<WechatQrcodeResult>({
        url: '/userservice/auth/wechat/qrcode/USER_LOGIN',
        method: 'get',
        params,
    });

// GET /userservice/auth/wechat/getScanResult/{uuid} - 获取微信扫码状态
export const getScanResult = (uuid: string) =>
    request({
        url: `/userservice/auth/wechat/getScanResult/${uuid}`,
        method: 'get',
    });

// GET /userservice/auth/captchaImage - 获取图片验证码
export const captchaImage = () =>
    request({
        url: '/userservice/auth/captchaImage',
        method: 'get',
    });

// POST /userservice/auth/login - 账号密码登录
export const login = (data: LoginData) =>
    request({
        url: '/userservice/auth/login',
        method: 'post',
        data,
    });

// GET /userservice/auth/sendMsg - 获取短信验证码
export const sendMsg = (params: SendMsgParams) =>
    request({
        url: '/userservice/auth/sendMsg',
        method: 'get',
        params,
    });

// POST /userservice/auth/phoneLogin - 短信验证码登录
export const phoneLogin = (data: Omit<LoginData, 'password'>) =>
    request({
        url: '/userservice/auth/phoneLogin',
        method: 'post',
        data,
    });

// POST /userservice/auth/phoneRegister - 手机号注册
export const phoneRegister = (data: LoginData) =>
    request({
        url: '/userservice/auth/phoneRegister',
        method: 'post',
        data,
    });

// POST /userservice/auth/user/profile/phoneValidate - 绑定手机号
export const phoneValidate = (data: PhoneRegisterData) =>
    request({
        url: '/userservice/auth/user/profile/phoneValidate',
        method: 'post',
        data,
    });

// GET /userservice/auth/getInfo - 获取用户信息
export const getInfo = () =>
    request<AuthInfoResult>({
        url: '/userservice/auth/getInfo',
        method: 'get',
    });

// POST /userservice/auth/loginOut - 退出登录
export const logout = () =>
    request({
        url: '/userservice/auth/loginOut',
        method: 'post',
    });

// POST /api/portal/banner/list - 获取官网轮播图列表
export const getPortalBannerList = () =>
    request<PortalBannerItem[]>({
        url: '/api/portal/banner/list?type=7',
        method: 'post',
    });
